// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentPage_wrapper__2AUDR"};